/**
 * @module userManager
 */
// Import made to reuse web user manager code and overwrite the tizen specific logic
import { default as userManager } from "../../../web/manager/user/user";
import { checkVoucherEligiblity,checkEvoucherEligiblity,eVoucherProvision,promotionShown } from "./voucher-eligibility";

export const user = {
  ...userManager,
  checkVoucherEligiblity,
  checkEvoucherEligiblity,
  eVoucherProvision,
  promotionShown
  
};
